import { render, staticRenderFns } from "./DirecionalidadSection.vue?vue&type=template&id=0c853c85&scoped=true&"
import script from "./DirecionalidadSection.vue?vue&type=script&lang=js&"
export * from "./DirecionalidadSection.vue?vue&type=script&lang=js&"
import style0 from "./DirecionalidadSection.vue?vue&type=style&index=0&id=0c853c85&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c853c85",
  null
  
)

export default component.exports